import React from 'react';
import { returnLocalisedPath } from '../../../../utils/globals';
import { withLocale } from '../../../../utils/hocs';
import {
  ICollection,
  IImage,
  ILabel,
} from '../../../../utils/types/contentful';
import { CollectionShopCard } from '../../../UI/Cards/Collection/Shop/collectionShopCard';
import { Link } from '../../../UI/Elements/Link';

export interface ShopCollectionItemProps {
  label: ILabel;
  subLabel: ILabel;
  collection: ICollection;
  image: IImage;
}

export const ShopCollectionItem: React.FC<ShopCollectionItemProps> = withLocale(
  ({ category, label, subLabel, image }) => (
    <Link
      title='Go to collection page'
      className='w-full'
      slug={category.slug}>
      <CollectionShopCard
        category={category}
        label={label}
        subLabel={subLabel}
        image={image}
      />
    </Link>
  )
);
